Nette.addWarning = function(elem, message) {
	var $input = $(elem);
	var $text = $input.siblings('.help-block');
	if (!$text.length) {
		// Pokud je input datepicker, warning se musí vložit až za tlačítko pro otevření kalendáře, které následuje
		if ($input.is('.hasDatepicker')) {
			$input = $input.next();
		}
		$text = $('<span>').addClass('help-block').insertAfter($input);
	}
	$text.html(message);
};

Nette.removeWarning = function(elem) {
	var $input = $(elem);
	$input.siblings('.help-block').remove();
};

Nette.getValue = function(elem) {
	var i;
	if (!elem) {
		return null;

	} else if (!elem.tagName) { // RadioNodeList, HTMLCollection, array
		return elem[0] ? Nette.getValue(elem[0]) : null;

	} else if (elem.tagName.toLowerCase() === 'form') {
		return null;

	} else if (elem.getAttribute && elem.getAttribute('data-ajax-select') && $(elem).hasClass('select2-hidden-accessible')) {
		return $(elem).val();

	} else if (elem.type === 'radio') {
		var elements = elem.form.elements; // prevents problem with name 'item' or 'namedItem'
		for (i = 0; i < elements.length; i++) {
			if (elements[i].name === elem.name && elements[i].checked) {
				return elements[i].value;
			}
		}
		return null;

	} else if (elem.type === 'file') {
		return elem.files || elem.value;

	} else if (elem.tagName.toLowerCase() === 'select') {
		var index = elem.selectedIndex,
			options = elem.options,
			values = [];

		if (elem.type === 'select-one') {
			return index < 0 ? null : options[index].value;
		}

		for (i = 0; i < options.length; i++) {
			if (options[i].selected) {
				values.push(options[i].value);
			}
		}
		return values;

	} else if (elem.name && elem.name.match(/\[\]$/)) { // multiple elements []
		var elements = elem.form.elements[elem.name].tagName ? [elem] : elem.form.elements[elem.name],
			values = [];

		for (i = 0; i < elements.length; i++) {
			if (elements[i].type !== 'checkbox' || elements[i].checked) {
				values.push(elements[i].value);
			}
		}
		return values;

	} else if (elem.type === 'checkbox') {
		return elem.checked;

	} else if (elem.tagName.toLowerCase() === 'textarea') {
		return elem.value.replace("\r", '');

	} else {
		return elem.value.replace("\r", '').replace(/^\s+|\s+$/g, '');
	}
};


Number.parseFloat = function(i) {
	return parseFloat(i.replace(',', '.'));
};


/**
 * Validates form element against given rules.
 */
Nette.validateControl = function(elem, rules, onlyCheck, value) {
	elem = elem.tagName ? elem : elem[0]; // RadioNodeList
	rules = rules || Nette.parseJSON(elem.getAttribute('data-nette-rules'));
	value = value === undefined ? {value: Nette.getEffectiveValue(elem)} : value;
	var form = (elem.tagName.toLowerCase() === 'form' ? elem : elem.form);

	for (var id = 0, len = rules.length; id < len; id++) {
		var rule = rules[id],
			op = rule.op.match(/(~)?([^?]+)/),
			curElem = rule.control ? form.elements.namedItem(rule.control) : elem;

//		if (form === elem){
//			console.log(rule);
//		}

		if (!curElem) {
			continue;
		}

		rule.neg = op[1];
		rule.op = op[2];
		rule.condition = !!rule.rules;
		curElem = curElem.tagName ? curElem : curElem[0]; // RadioNodeList

		var curValue = elem === curElem ? value : {value: Nette.getEffectiveValue(curElem)},
			success = Nette.validateRule(curElem, rule.op, rule.arg, curValue);

		if (success === null) {
			continue;
		} else if (rule.neg) {
			success = !success;
		}

		if (rule.condition && success) {
			if (!Nette.validateControl(elem, rule.rules, onlyCheck, value)) {
				return false;
			}
		} else if (!rule.condition && !success) {
			if (Nette.isDisabled(curElem)) {
				continue;
			}
			if (!onlyCheck) {
				var arr = Nette.isArray(rule.arg) ? rule.arg : [rule.arg],
					message = rule.msg.replace(/%(value|\d+)/g, function(foo, m) {
						return Nette.getValue(m === 'value' ? curElem : form.elements.namedItem(arr[m].control));
					});
				Nette.addError(curElem, message);
			}
			return false;
		}
	}
	return true;
};

Nette.validateForm = function(sender, onlyCheck) {
	var form = sender.form || sender,
		scope = false;

	if (form['nette-submittedBy'] && form['nette-submittedBy'].getAttribute('formnovalidate') !== null) {
		var scopeArr = Nette.parseJSON(form['nette-submittedBy'].getAttribute('data-nette-validation-scope'));
		if (scopeArr.length) {
			scope = new RegExp('^(' + scopeArr.join('-|') + '-)');
		} else {
			return true;
		}
	}

	var radios = {}, i, elem;

	for (i = 0; i < form.elements.length; i++) {
		elem = form.elements[i];

		if (elem.tagName && !(elem.tagName.toLowerCase() in {input: 1, select: 1, textarea: 1, button: 1})) {
			continue;

		} else if (elem.type === 'radio') {
			if (radios[elem.name]) {
				continue;
			}
			radios[elem.name] = true;
		}

		if ((scope && !elem.name.replace(/]\[|\[|]|$/g, '-').match(scope)) || Nette.isDisabled(elem)) {
			continue;
		}

		if (!Nette.validateControl(elem, undefined, onlyCheck)) {
			beforeunload_enable = true;
			return false;
		}
	}

	return Nette.validateControl(form, undefined, onlyCheck);
};


Nette.toggle = function(id, visible, srcElement) {
	var elem = document.getElementById(id);
	if (elem) {
		if (elem.dataset.display === undefined) {
			if (elem.style.display === 'none') {
				elem.dataset.display = '';
			} else {
				elem.dataset.display = elem.style.display;
			}
		}
		elem.style.display = visible ? elem.dataset.display : 'none';
	}
};

Nette.addError = function(elem, message) {
	if (message) {
		alert(message);
	}

	if (!elem) return;

	if (elem.focus) {

		var $elem = $(elem);

		if (
			$elem.prev().length
			&&
			$elem.prev().hasClass('select2-container')
		) {
			// Select 2

			if (elem.hasAttribute('multiple')) {
				// Select2 multiselect
				elem = elem.previousSibling.getElementsByClassName('select2-input')[0];

			} else {
				// Select2 singleselect
				elem = elem.previousSibling.getElementsByClassName('select2-focusser')[0];
			}

			elem.focus();

		} else if ($elem.data('inplaceEditable')) {
			// adt-inplace-editable input

			$elem.inplaceEditable('toEditMode');

		} else {
			// Normální input (např.: text, password, textarea, radio, ...)

			// pro některé povinné inputy, které nemají focus
			// např podmíněné  ve formuláři "addConditionOn"
			elem.focus();
		}
	}
};